import * as React from "react";
import styles from "./AutoResizeTextArea.scss";

interface IProps {
    id?: string;
    value: string;
    className?: string;
    maxHeight?: number;
    onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
    onFocus?: React.FocusEventHandler<HTMLTextAreaElement>;
    onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
    disableNewLines?: boolean;
    placeholder?: string;
}

interface IState {
    value: string;
}

export class AutoResizeTextArea extends React.Component<IProps, IState> {
    private areaRef = React.createRef();

    constructor(props: IProps) {
        super(props);

        this.state = {
            value: props.value
        };

        this.onChange = this.onChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.resize = this.resize.bind(this);
        this.delayedResize = this.delayedResize.bind(this);

        this.delayedResize();
    }

    public componentDidMount() {
        window.addEventListener("resize", this.delayedResize);
    }

    private onChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
        event.currentTarget.value = this.props.disableNewLines ?
            event.currentTarget.value.replace(/\n/g, "") :
            event.currentTarget.value;

        this.setState({
            value: event.currentTarget.value
        });
        this.resize();

        if (this.props.onChange) {
            this.props.onChange(event);
        }
    }

    private get textArea(): HTMLTextAreaElement {
        return this.areaRef.current! as HTMLTextAreaElement;
    }

    private resize() {
        if (this.textArea) {
            this.textArea.style.height = "auto";
            // If the height of the textarea is higher than the maxHeight we set it to max height otherwise to the scrollheight
            this.textArea.style.height =
                this.props.maxHeight && this.props.maxHeight < this.textArea.scrollHeight
                    ? this.props.maxHeight + "px"
                    // Four pixels are added otherwise the scrollbar always appears
                    : (this.textArea.scrollHeight + 4) + "px";
        }
    }

    private delayedResize() {
        setTimeout(this.resize, 0);
    }

    private onKeyDown(e: React.KeyboardEvent<HTMLTextAreaElement>) {
        if (this.props.disableNewLines && e.keyCode === 13) {
            e.preventDefault();
        }
        this.delayedResize();
    }

    public focus() {
        this.textArea.focus();
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.value !== prevState.value) {
            partialState.value = nextProps.value;
        }

        return partialState;
    }

    public render() {
        return (
            <textarea
                ref={this.areaRef}
                id={this.props.id}
                className={`${styles.textArea} ${this.props.className || ""}`}
                onChange={this.onChange}
                onCut={this.delayedResize}
                onPaste={this.delayedResize}
                onDrop={this.delayedResize}
                onFocus={this.props.onFocus}
                onBlur={this.props.onBlur}
                onKeyDown={this.onKeyDown}
                rows={1}
                value={this.state.value}
                placeholder={this.props.placeholder} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Common/Input/AutoResizeTextArea/AutoResizeTextArea.tsx